module.exports = __webpack_public_path__ + "static/media/iStock-1286297244.ab463c65.jpg";